"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_UPDATED_CHATS_FAILED = exports.GET_UPDATED_CHATS_SUCCEEDED = exports.GET_UPDATED_CHATS_REQUESTED = void 0;
const service_1 = __importDefault(require("../../services/chats/service"));
exports.GET_UPDATED_CHATS_REQUESTED = "GET_UPDATED_CHATS_REQUESTED";
exports.GET_UPDATED_CHATS_SUCCEEDED = "GET_UPDATED_CHATS_SUCCEEDED";
exports.GET_UPDATED_CHATS_FAILED = "GET_UPDATED_CHATS_FAILED";
function default_1(updatedSince) {
    return (dispatch) => __awaiter(this, void 0, void 0, function* () {
        // This function is called every second and we do not currently listen for GET_UPDATED_CHATS_REQUESTED event so
        // in order to remove noise and aid debugging these events are not being dispatched for now.
        //
        // const requestEvent: GetUpdatedChatsRequestedEvent = {
        //     type: GET_UPDATED_CHATS_REQUESTED
        // };
        //
        // dispatch(requestEvent);
        const response = yield service_1.default.getUpdates({
            updatedSince: updatedSince,
            messageCountForTopChat: null
        });
        let outcomeEvent;
        if (response.kind === "success") {
            outcomeEvent = {
                type: exports.GET_UPDATED_CHATS_SUCCEEDED,
                payload: {
                    chats: response.chats,
                    blockedUsers: response.blockedUsers,
                    latestUpdateTimestamp: response.latestUpdateTimestamp
                }
            };
        }
        else {
            outcomeEvent = {
                type: exports.GET_UPDATED_CHATS_FAILED,
                httpError: response.kind === "httpError" ? response : undefined
            };
        }
        // This function is called every second and the only events that make any state changes are the
        // GET_UPDATED_CHATS_SUCCEEDED which have non-empty chats. So we can ignore the events with empty chats.
        if (outcomeEvent.type !== exports.GET_UPDATED_CHATS_SUCCEEDED || outcomeEvent.payload.chats.length) {
            dispatch(outcomeEvent);
        }
        return outcomeEvent;
    });
}
exports.default = default_1;
